import _objectWithoutProperties from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var _excluded = ["sadad", "hasSadad", "sadadError"];
import React from "react";
var __jsx = React.createElement;
import { useParams } from "react-router-dom";
import Loader from "@componentsShared/Loader/Loader";
import RemainingPaymentComponent from "@/_MiniApps/RemainingPaymentComponent/RemainingPaymentComponent";
import Layout from "@/_LayoutsRelated/layout/Layout";
import stl from "./RemainingPayment.module.css";
import MobileHeader1 from "@/_LayoutsRelated/mobileHeaders/mobileHeader1/MobileHeader1";
import { useTranslation } from "@i18n";
import useHelpers from "@hooks/useHelpers";
import { api__getRemainingOrderDetails } from "@/apis/checkout/remainingPayments";
import useApi from "@hooks/useApi";
import useButtonLoading from "@hooks/useButtonLoading";
var RemainingPayment = function RemainingPayment() {
  var _remainingOrder$payme, _remainingOrder$payme2;
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useParams = useParams(),
    id = _useParams.id;
  var buttonLoading = useButtonLoading();
  var _useApi = useApi([id], function () {
      return api__getRemainingOrderDetails(id);
    }),
    _useApi2 = _slicedToArray(_useApi, 3),
    loading = _useApi2[0],
    error = _useApi2[1],
    data = _useApi2[2];
  if (loading) return /*#__PURE__*/React.createElement(Loader, null);
  var _ref = data || {},
    sadad = _ref.sadad,
    hasSadad = _ref.hasSadad,
    sadadError = _ref.sadadError,
    remainingOrder = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Layout, {
    hideAppBanner: true,
    authenticationMsg: true,
    headHideLinks: true,
    hideOrangeHeadBtn: true,
    hasNavBar: true,
    mobileHasBack: true,
    hideHeaderOnmobile: true,
    custommobileHeader: /*#__PURE__*/React.createElement(MobileHeader1, {
      title: t("collect_remaining_amount", {
        ns: "web_common"
      }),
      buttonFunction: function buttonFunction() {
        navigateTo("/tracking-checkout-details/".concat(id));
      },
      NoBack: true,
      className: stl.greenBackGround
    })
  }, remainingOrder && Object.keys(remainingOrder).length > 0 ? /*#__PURE__*/React.createElement("div", {
    className: stl.remainingContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.remainingCardContainer
  }, /*#__PURE__*/React.createElement(RemainingPaymentComponent, {
    isCash: true,
    buttonLoading: buttonLoading,
    order: remainingOrder,
    sadad: sadad,
    hasSadad: hasSadad,
    sadadError: sadadError,
    banks: remainingOrder && (remainingOrder === null || remainingOrder === void 0 ? void 0 : (_remainingOrder$payme = remainingOrder.paymentOptions) === null || _remainingOrder$payme === void 0 ? void 0 : _remainingOrder$payme.banks),
    enableAllPayments: remainingOrder && (remainingOrder === null || remainingOrder === void 0 ? void 0 : (_remainingOrder$payme2 = remainingOrder.paymentOptions) === null || _remainingOrder$payme2 === void 0 ? void 0 : _remainingOrder$payme2.enabled),
    title: t("collect_remaining_amount", {
      ns: "web_common"
    }),
    id: id,
    date: remainingOrder === null || remainingOrder === void 0 ? void 0 : remainingOrder.date
  }))) : null);
};
export default RemainingPayment;